import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, useLocation, useNavigate } from "react-router";

import { NetworkRow } from "@/entities/wallet";
import { ROUTES } from "@/shared/config";
import { staggerIndex } from "@/shared/lib";
import { Button } from "@/shared/ui";
import { TopBar } from "@/widgets/top-bar";

/**
 * Шаг 2. Figma: `Wallet · Select Network` (23:122).
 *
 * Выбор предыдущего шага переносится через `location.state` — так же, как в
 * мастере покупки. Прямой заход без состояния отправляет в начало мастера:
 * иначе экран показал бы пустой список сетей неизвестно какого актива.
 */
export function DepositNetworkPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const state = location.state as
    | { asset?: string; networks?: string[]; returnTo?: string }
    | null;
  const [network, setNetwork] = useState<string | null>(null);

  if (!state?.asset || !state.networks) return <Navigate to={ROUTES.depositAsset} replace />;

  const { asset, networks } = state;

  return (
    <div className="flex flex-col gap-3 px-5 py-3">
      <TopBar title={t("wallet.selectNetwork")} subtitle={asset} />

      <p className="rounded-2xl border border-border-subtle bg-background-elevated p-4 text-caption font-normal text-text-secondary">
        {t("wallet.networkWarning")}
      </p>

      <ul className="flex flex-col gap-3">
        {networks.map((item, index) => (
          <li key={item} className="stagger" style={staggerIndex(index)}>
            <NetworkRow network={item} selected={network === item} onSelect={() => setNetwork(item)} />
          </li>
        ))}
      </ul>

      <Button
        size="cta"
        block
        disabled={network === null}
        onClick={() =>
          void navigate(ROUTES.depositAmount, {
            state: { asset, network, ...(state.returnTo ? { returnTo: state.returnTo } : {}) },
          })
        }
      >
        {t("common.next")}
      </Button>
    </div>
  );
}
